export default __webpack_public_path__ + "static/media/android_badge.a55456d9.svg";